import { Relations, UserId } from "@inrev/common";
import { useFetchAdminActionItemsForRelation } from "@portal/api/action-item/admin";
import { Spinner } from "@portal/components/ui/Spinner";
import { ActionItemsSelectionProvider } from "@portal/providers/ActionItemsSelectionProvider";
import { AdminActionItemView } from "./AdminActionItemView";

export const AdminActionItemTool = ({
	relation,
	defaultUnderwriterId,
}: {
	relation: Relations.ActionItems;
	defaultUnderwriterId: UserId;
}) => {
	const { actionItems, actionItemsIsLoading } = useFetchAdminActionItemsForRelation(relation);

	if (actionItems === undefined || actionItemsIsLoading) {
		return (
			<div className="flex justify-center items-center">
				<Spinner />
			</div>
		);
	}

	return (
		<ActionItemsSelectionProvider>
			<AdminActionItemView
				defaultUnderwriterId={defaultUnderwriterId}
				actionItemMap={actionItems}
				relation={relation}
			/>
		</ActionItemsSelectionProvider>
	);
};
